import { provideApolloClient } from '@vue/apollo-composable';
import builderApolloClient from '@/modules/apollo/builder.apollo';

export enum Client {
  BUILDER = 'builder',
}

export enum CachePolicy {
  CACHE_FIRST = 'cache-first',
  CACHE_ONLY = 'cache-only',
  CACHE_AND_NETWORK = 'cache-and-network',
  NETWORK_ONLY = 'network-only',
  NO_CACHE = 'no-cache',
  STANDBY = 'standby',
}

export const BuilderClient = { clientId: Client.BUILDER };

export const provideBuilderClient = () =>
  provideApolloClient(builderApolloClient);

// Add all new clients to this map
// This is used to help the apollo wrapper correctly set the client at the time of usage.
export const clientMap = {
  [Client.BUILDER]: {
    client: BuilderClient,
    provide: () => provideBuilderClient(),
  },
};

type ApolloClientKeys = keyof typeof Client;
export type ApolloClientIds = typeof Client[ApolloClientKeys];
